// extracted by mini-css-extract-plugin
export var label = "_ag-1";
export var reminder = "_ag-0";